import { BuildingIcon, GraduationCapIcon, UserIcon, UsersIcon } from '@/shared/icons';
import { brandTextEmphasisClassName, focusRingClassNameStrong } from '@/shared/config/theme';
import type { AccountType, AccountTypeOption, RegistrationStep } from '@/features/auth/types';

export const AUTH_INPUT_CLASS = `w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 transition-all focus:bg-white ${focusRingClassNameStrong}`;

export const AUTH_LINK_CLASS = 'auth-link font-semibold transition-colors';

/** @deprecated Use `<Button variant="auth" fullWidth className="rounded-xl py-4" />` */
export const AUTH_PRIMARY_BUTTON_CLASS =
  'auth-primary-button w-full rounded-xl py-4 font-semibold shadow-lg transition-all hover:shadow-xl disabled:cursor-not-allowed';

/** @deprecated Use `<Button variant="authContinue" className="rounded-xl px-10 py-3" />` */
export const AUTH_CONTINUE_BUTTON_CLASS =
  'auth-continue-button rounded-xl px-10 py-3 font-semibold shadow-lg transition-all disabled:cursor-not-allowed';

export const AUTH_BRAND_BADGE_CLASS =
  'auth-brand-badge inline-flex items-center justify-center shadow-lg';

export const AUTH_BRAND_ACCENT_CLASS = 'auth-brand-accent';

/** Auth card / registration step padding */
export const AUTH_CARD_PADDING_CLASS = 'p-6 sm:p-12';

export const ACCOUNT_TYPE_OPTIONS: readonly AccountTypeOption[] = [
  {
    type: 'student',
    label: 'Student',
    Icon: GraduationCapIcon,
    iconClassName: brandTextEmphasisClassName,
    selectedBgClassName: 'bg-blue-50',
  },
  {
    type: 'instructor',
    label: 'Teacher or Professor',
    Icon: UsersIcon,
    iconClassName: brandTextEmphasisClassName,
    selectedBgClassName: 'bg-teal-50',
  },
  {
    type: 'management',
    label: 'Staff',
    Icon: BuildingIcon,
    iconClassName: 'text-orange-500',
    selectedBgClassName: 'bg-orange-50',
  },
  {
    type: 'parent',
    label: 'Parent',
    Icon: UserIcon,
    iconClassName: 'text-purple-600',
    selectedBgClassName: 'bg-purple-50',
  },
] as const;

export const REGISTRATION_STEPS: readonly RegistrationStep[] = [
  'account-type',
  'find-school',
  'information',
] as const;

/**
 * Auth `AccountType` → MyU backend `userTypeId` enum (see
 * `src/features/profile/userType.ts` for the full table). Only the four
 * registration-selectable types are mapped here.
 *
 *   student     → 2  (Student)
 *   instructor  → 1  (Teacher / Professor — backend "Faculty")
 *   management  → 3  (Department / Club    — backend "Club")
 *   parent      → 5  (Parent)
 */
export const ACCOUNT_TYPE_TO_USER_TYPE_ID: Readonly<Record<AccountType, number>> = {
  student: 2,
  instructor: 1,
  management: 3,
  parent: 5,
};
